import request from '@/utils/request'

export function loginByUsername(username, password) {
  const data = {
    username,
    password,
  }
  return request({
    url: '/api/public/login',
    method: 'post',
    data
  })
}
export function logout() {
  return request({
    url: '/api/app/logout',
    method: 'get'
  })
}

export function getUserInfo(data) {
  return request({
    url: '/api/app/userInfo',
    method: 'post',
    data
  })
}
